import { CONSTANTS } from '../constants'

export const sendFeedbackEmail = () => {
  window.open(
    `mailto:${CONSTANTS.EMAILS.SUPPORT}?subject=Feedback for MSKexperts.com&body=Please tell us what's on your mind! Any questions, comments, suggestions, bug reports are all welcome.`,
  )
}
